import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/event_contacts`, {params: {...filter}})
  },

  indexByEvent({event_id, filter}) {
    return Http.get(`/events/${event_id}/event_contacts`, {params: {...filter}})
  },


  create(event_contacts){
    return Http.post(`/event_contacts`, {event_contacts: {
      ...event_contacts,
    }})
  },

  update(event_contacts){
    return Http.put(`/event_contacts/${event_contacts.id}`, {
      event_contacts: {
        ...event_contacts,
      },
    });
  },

  show(id) {
    return Http.get(`/event_contacts/${id}`);
  },

  delete(id){
    return Http.delete(`/event_contacts/${id}`)
  }

}